module.exports = __webpack_public_path__ + "img/sld_grid_ta1_disable.40fb9e3f.svg";